import axios from "axios";
import authHeader from "./auth-header";
import { API_URL_COMMON } from "./http.common";

// const API_URL = `https://magicstamp-portal-sa.parktechnology.com`;
const API_URL = `${API_URL_COMMON}`;

class StampcardService {
  getIcons({ account_urn, type, theme }) {
    return axios({
      method: "get",
      url: `${API_URL}/stamp-cards/icons/${type}/${theme}`,
      headers: authHeader(null, {
        account_urn,
      }),
    });
  }

  deleteStampcard(data) {
    return axios({
      method: "post",
      url: `${API_URL}/stamp-card-deletions`,
      headers: authHeader(),
      data,
    });
  }

  uploadIcon({ data, accUrn, businessSlug }) {
    return axios({
      method: "post",
      url: `${API_URL}/icon-manager/${businessSlug}/card-assets`,
      headers: authHeader("multipart/form-data", { account_urn: accUrn }),
      data: data,
    });
  }

  uploadLogo({ data, accUrn, businessSlug }) {
    return axios({
      method: "post",
      url: `${API_URL}/icon-manager/${businessSlug}/logos`,
      headers: authHeader("multipart/form-data", { account_urn: accUrn }),
      data: data,
    });
  }

  uploadBackground({ data, accUrn, businessSlug }) {
    return axios({
      method: "post",
      url: `${API_URL}/icon-manager/${businessSlug}/backgrounds`,
      headers: authHeader("multipart/form-data", { account_urn: accUrn }),
      data: data,
    });
  }
}

export default new StampcardService();
